import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { StopDetailedView } from '../types';
import Icons from '../../../components/icons';
import pallet from '../../../layouts/pallet';

export const getStopsColumns = (
  onEdit: (stop: StopDetailedView) => void,
  onDelete: (stop: StopDetailedView) => void,
  onAssignStudent: (stop: StopDetailedView) => void,
  isTransportFeesEnabled: boolean
): GridColDef[] => {
  const chargesColumn: GridColDef[] = isTransportFeesEnabled
    ? [
        {
          field: 'charges',
          headerName: 'Yearly Charge',
          width: 130,
          renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
            params.row.charges?.yearly != null
              ? `${params.row.charges.yearly}`
              : '-'
        }
      ]
    : [];

  return [
    {
      field: 'stopNumber',
      headerName: 'Stop No.',
      width: 80,
      type: 'number',
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        params.row.stopNumber
    },
    { field: 'name', headerName: 'Stops Name', width: 200 },
    {
      field: 'studentsCount',
      headerName: 'Students',
      width: 100,
      type: 'number',
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        params.row.students.length || 0
    },
    {
      field: 'travelTime',
      headerName: 'Travel Time',
      width: 100,
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        `${params.row.travelTime || 0} min`
    },
    {
      field: 'triggerStop',
      headerName: 'Trigger Stop',
      width: 200,
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        params.row.triggerStopName ? params.row.triggerStopName : '-'
    },
    {
      field: 'location',
      headerName: 'Location',
      width: 250,
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        params.row.location
          ? `lat: ${params.row.location.lat}, long:${params.row.location.long}`
          : '-'
    },
    {
      field: 'offsetLocation',
      headerName: 'Offset Location',
      width: 250,
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) =>
        params.row.offsetLocation
          ? `lat: ${params.row.offsetLocation.lat}, long: ${params.row.offsetLocation.long}`
          : '-'
    },
    ...chargesColumn,
    {
      field: 'edit',
      headerName: 'Actions',
      align: 'center',
      width: 70,
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) => {
        return (
          <Box>
            <Tooltip title='Edit'>
              <span>
                <IconButton
                  size='small'
                  onClick={() => onEdit(params.row)}
                  aria-label='delete bus'
                  color='error'
                >
                  <Icons.EditBlackOutlined />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Delete'>
              <span>
                <IconButton
                  size='small'
                  onClick={() => onDelete(params.row)}
                  aria-label='delete bus'
                  color='error'
                >
                  <Icons.Delete />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      }
    },

    {
      field: 'assignStudent',
      headerName: 'Assign Student',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams<any, StopDetailedView>) => {
        return (
          <Button
            variant='contained'
            onClick={() => onAssignStudent(params.row)}
            sx={{
              backgroundColor: pallet.green2,
              color: pallet.white,
              borderRadius: '4px',
              height: '30px',
              '&:hover': {
                backgroundColor: pallet.green2
              }
            }}
          >
            <Icons.AssignStudents style={{ marginRight: '6px' }} />
            Assign Student
          </Button>
        );
      }
    }
  ];
};
